<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
  export default {
    mounted() {
      window.onpopstate = () => {
        if (!this.allowBack) {    //    这个allowBack 是存在vuex里面的变量
          history.go(1)
        }
      }
    },
    name: "App",
  };
</script>

<style lang="less">
	/* 引入重置样式 */
	@import "assets/css/base.css";
	#app{
		font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu,"Helvetica Neue",Arial,sans-serif !important;
    font-family: 'myfont' !important;
    font-weight: 600;
  }
  .el-main{
    // padding: 0 !important;
  }
  // 整体样式
  .content {
	width: 100%;
	height: 100%;
	background-color: #F6F6F6;
	// border-radius: 10px;
    position: relative;
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu,"Helvetica Neue",Arial,sans-serif !important;
  font-family: 'myfont' !important;
	color: #333;
	// box-shadow: 0 5px 14px -5px rgba(0,0,0,.3);
    .content_header {
      width: 100%;
      min-height: 47px;
	  background-color: #F6F6F6;
      border-radius: 10px 10px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
	  box-sizing: border-box;
	  border-bottom: 2px solid #dedede;
    }
	.content_search{
      width: 100%;
      min-height: 60px;
      background-color: #fff;
      // align-items: center;
      padding: 0 15px;
	  box-sizing: border-box;
	  border-bottom: 2px solid #dedede;
	  // border: 2px solid #f6f6f6;
	  // border-radius: 10px;
	  overflow: hidden;
	}
	.content_left {
		width: 15%;
		height: calc(100% - 115px);
		overflow-y: auto;
		background-color: #f6f6f6;
		border-radius: 0;
		padding: 10px 0;
		text-align: center;
		float: left;
	}
    .content_table {
      width: 100%;
      // height: calc(100vh - 190px);
      height: calc(100% - 115px);
      overflow-y: auto;
      background-color: #fff;
      border-radius: 0;
      padding: 0;
      text-align: center;
    }
  }
  .content .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .el-submenu__title:hover {
    // background-color: #D6E1FE;
    // background-color: #409EFF; // newStyle
	background-image: linear-gradient(#2E9BDC, #1D61A8, #2E9BDC);
	color: #fff !important;
  }
  .el-submenu__title i {
    // color: #333333;
    color: #fff;
  }
  .el-submenu .el-submenu__title:hover {
	background-image: linear-gradient(#2E9BDC, #1D61A8, #2E9BDC);
	color: #fff !important;
  }
  .el-submenu .el-submenu__title{
	  height: 45px !important;
	  line-height: 45px !important;
	  // color: #333333 !important;
	  // color: #fff !important; // newStyle
      background-color: #1D61A8 !important; // newStyle
      color: #fff !important; // newStyle
	  // color: #C4C5C8 !important; // newStyle
	  font-size: 14px;
	  font-weight: 600;
  }
  .el-menu {
    background: none;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    // background-color: #D6E1FE;
    // background-color: #409EFF; // newStyle
    background-color: rgba(50, 105, 249,.2); // newStyle
  }
  .sidebar-el-menu > li.is-active {
    // background-color: #D6E1FE !important;
    // background-color: #409EFF !important; // newStyle
    // background-color: #393D49 !important; // newStyle
      background-color: #1D61A8 !important; // newStyle
    // color: #3269F9 !important;
    color: #fff !important; // newStyle
	font-size: 14px;
	font-weight: 600;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 5px;
      height: 30px;
      // background: #3269F9;
      background: #fff;
      opacity: 1;
      border-radius: 0px 10px 10px 0px;
      margin: auto;
    }
  }
  .sidebar-el-menu > li {
      background-color: #1D61A8 !important; // newStyle
	  color: #fff !important; // newStyle
	  border-bottom: 1px solid;
	  border-image: linear-gradient(90deg, #1D61A8 0%, #fff 50%, #1D61A8 100%) 2 2 2;
  }
  .sidebar-el-menu > li:hover {
	background-image: linear-gradient(#2E9BDC, #1D61A8, #2E9BDC);
	color: #fff !important;
  }
  .sidebar-el-menu > li ul {
    background-color: #FFFFFF !important;
    // background-color: #474c5b !important; // newStyle
    // background-color: #282B33 !important; // newStyle
  }
  .el-menu .is-active .el-submenu__title
    // .el-menu .is-active.el-menu-item
  {
    // background-color: #D6E1FE !important;
    // background-color: #409EFF !important; // newStyle
    // background-color: #393D49 !important; // newStyle
    background-color: #1D61A8 !important; // newStyle
    // color: #333333 !important;
    color: #fff !important; // newStyle
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 5px;
      height: 30px;
      // background: #3269F9;
      background: #fff;
      opacity: 1;
      border-radius: 0px 10px 10px 0px;
      margin: auto;
    }
  }
  .el-menu-item.is-active {
    // background-color: #D6E1FE !important;
    // background-color: #409EFF !important; // newStyle
    background-color: rgba(50, 105, 249,.2); // newStyle
    color: #3269F9 !important;
  }
  .el-menu-item.is-opened {
    // background-color: #D6E1FE !important;
    // background-color: #409EFF !important; // newStyle
    color: #3269F9 !important;
  }
  .el-menu-item{
	  height: 45px !important;
	  line-height: 45px !important;
	  // color: #333333 !important;
	  // color: #fff !important; // newStyle
	  // color: #C4C5C8 !important; // newStyle
	  color: #333333 !important; // newStyle
	  font-size: 14px;
	  font-weight: 600;
    // left: -6px;
  }
  .item2{
	  height: 45px !important;
	  line-height: 45px !important;
	  // color: #333333 !important;
    // color: #fff !important; // newStyle
	  color: #C4C5C8 !important; // newStyle
	  font-size: 14px !important;
  }
  .el-drawer {
    // border-radius: 20px;
  }
  .el-drawer__container {
    outline: none;
    overflow: auto;
  }
  .el-drawer:focus {
    outline: none;
  }
  * {
    outline: none;
  }
  .el-drawer__wrapper {
    height: calc(100vh - 120px);
    top: auto;
    position: absolute;
    .el-drawer__container {
      .el-drawer__body {
        .drawer_header {
          width: 100%;
          height: 65px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e3e3e3;
          // background-color: #f4f4f4;

          width: 100%;
          height: 40px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          border-bottom: 1px solid #e3e3e3;
          background-color: #ffffff;
          > span {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-family: 'myfont' !important;
            font-weight: bold;
            color: #404952;
            line-height: 20px;
            padding-left: 15px;
          }
          .icon {
            width: 58px;
            height: 40px;
            // background: #dfdfdf;
            background: #82B1FF;
            // border-radius: 20px 0px 0px 0px;
            text-align: center;
            line-height: 40px;
          }
        }
        .info_form {
          height: calc(100vh - 316px) !important;
          height: calc(100vh - 290px) !important;
        }
        .drawer_content {
          height: calc(100vh - 244px);
          height: calc(100vh - 220px);
          overflow: auto;
          padding: 15px 20px;
          .menpai {
            margin-top: -10px;
            .dong {
              width: 60px;
              margin-right: 10px;
            }
            .shi {
              width: 60px;
              margin-right: 10px;
            }
          }
        }
        .drawer_form {
          height: calc(100vh - 220px);
          overflow: auto;
          .menpai {
            margin-top: -10px;
            .dong {
              width: 60px;
              margin-right: 10px;
            }
            .shi {
              width: 60px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  /* 抽屉的底部按钮 */
  .drawer_btns {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    padding-left: 26px;
    border-top: 1px solid #e3e3e3;
  }
  .drawer_header_right {
    margin-left: auto;
    display: flex;
    align-items: center;
    height: 40px;
  }
  .el-dialog {
    // border-radius: 10px;
    width: 330px;
    width: 492px;
  }
  .el-middle-dialog .el-dialog {
    // border-radius: 20px;
    width: 410px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #e3e3e3;
    padding: 10px;
  }
  .el-dialog__title {
    font-weight: 600;
    color: #0c1c28;
	font-size: 14px !important;
  }
  .el-dialog--center .el-dialog__body {
    padding-bottom: 0;
	max-height: calc(100vh - 350px);
	overflow-y: scroll;
  }
  /* 对话框 关闭按钮样式 */
  .el-dialog__headerbtn {
    position: absolute;
    top: 8px !important;
    background: url("assets/close.png") left no-repeat;
    background-size: cover;
  }
  .el-dialog__headerbtn i {
    content: "";
    font-size: 25px;
    visibility: hidden;
  }
  .el-button {
    // border-radius: 5px;
  }
  /* 修改按钮样式 */
  .el-button--primary {
    color: #fff;
    background-color: #2962ff;
    border-color: #2962ff;
  }
  .content_search>.el-button--primary{
    color: #fff;
    background-color: #2889CB;
    border-color: #2889CB;
  }
  /* text btn颜色 */
  .el-button--text {
    color: #5b5a5a;
  }
  .el-radio {
    margin-right: 20px;
  }
  .el-radio-button__inner {
    width: 100px;
    height: 40px;
    color: #000000;
    border: none;
    font-size: 15px;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    border: none;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 0;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #82b1ff;
    font-weight: 500;
    color: #ffffff;
    box-shadow: none;
    border: none;
  }
  // 新增广告
  .el-radio-group .el-radio p {
    width: 112px;
    color: #8d8d8d;
  }
  // 整体样式
  .term {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    .term_header {
      width: 100%;
      height: 60px;
      background-color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-bottom: 20px;
      .term_search {
        width: 480px;
        display: flex;
        justify-content: space-between;
        .el-input {
          width: 400px;
        }
      }
    }
    .term_content {
      width: 100%;
      // height: calc(100vh - 270px);
      height: calc(100% - 120px);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      margin-bottom: 20px;
    }
  }
  .el-weight-drawer .el-table__body-wrapper {
    height: 94% !important;
    overflow: scroll;
  }
  // 卡片样式
  .term_card {
    width: 190px;
    height: 300px;
    border-radius: 20px;
    text-align: center;
    margin: 0 20px 20px 0;
    .el-image {
      padding-top: 18px;
    }
    .term_name {
      font-weight: bold;
      font-family: Microsoft YaHei;
      font-family: 'myfont' !important;
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      margin-left: auto;
      margin-top: 6px;
    }
    .term_aisle {
      margin-top: 10px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-family: 'myfont' !important;
      font-weight: 500;
      color: #000000;
      margin-bottom: 2px;
    }
    .term_status {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-family: 'myfont' !important;
      font-weight: 400;
      padding: 5px 0;
      line-height: 14px;
      .statu_true {
        color: #2ec580;
      }
      .statu_false {
        color: #bcbcbc;
      }
    }
    .term_btns {
      width: 100%;
      padding: 0 20px;
      border-top: 1px solid #f3f0f0;
      height: 42px;
      font-size: 26px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #0690ff;
      .disabled {
        color: #c4c4c4;
      }
    }
  }
  // 按钮样式
  .fix {
    background-color: #2962ff;
    color: #fff;
  }
  // 弹窗样式
  //重置密码
  .user_dialog {
    .center {
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-input {
        width: 252px;
        span {
          display: inline-block;
          cursor: pointer;
          font-size: 14px;
          color: #141414;
          margin: 0;
        }
      }
      span {
        font-size: 10px;
        margin-top: 5px;
      }
    }
    .checked {
      display: block;
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-family: 'myfont' !important;
      font-weight: 400;
      line-height: 18px;
      color: #141414;
    }
  }
  .user_dialog .el-input-group__append {
    padding: 0 10px;
    border-radius: 0 20px 20px 0;
  }

  .outcenter {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  // 弹窗样式
  .custo_dialog {
    // position: relative;
    z-index: 99;
    .randomClick {
      display: inline-block;
      padding: 9px;
      cursor: pointer;
    }
    .checked {
      margin: 5px 0 0 10px;
    }
    .guaForm {
      margin-left: 20%;
      span {
        margin-top: 20px;
        font-family: Source Han Sans CN;
        font-family: 'myfont' !important;
        font-weight: 400;
        color: #ff1f44;
        line-height: 20px;
      }
    }

    .huoForm {
      margin-left: 20%;
      span {
        margin-top: 20px;
        font-family: Source Han Sans CN;
        font-family: 'myfont' !important;
        font-weight: 400;
        color: #ff1f44;
        line-height: 20px;
      }
    }
    .menpai {
      margin-top: -10px;
      .dong {
        width: 60px;
        margin-right: 10px;
      }
      .shi {
        width: 60px;
        margin-right: 10px;
      }
    }
  }
  // 卡片选中样式
  .checked {
    background-color: #068fff;
    color: #fff;
    .term_btns {
      color: #fff !important;
    }
  }
  //图片上传成功
  .avatar {
    width: 110px;
    height: 110px;
    display: block;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 110px;
    height: auto;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #393D49;
  }
  .avatar-uploader-icon {
    font-size: 26px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    height: auto;
    line-height: 110px;
    text-align: center;
  }
  .el-upload-list--picture-card .el-upload-list__item{
	width: 110px !important;
	height: 110px !important;
  }
  .el-upload--picture-card{
	width: 110px !important;
	height: 110px !important;
	line-height: 110px !important;
  }
  // 进度条
  .el-progress-small {
    width: 160px;
    display: inline-block;
  }
  .el-date-range-picker.has-sidebar {
    width: 780px !important;
  }
  .el-date-picker.has-sidebar.has-time {
    width: 450px !important;
  }
  .mini-date-picker {
    width: 180px !important;
  }

  /* title */
  .header_title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
	line-height: 40px;
  }
  .header_p {
    font-size: 14px;
    font-family: Segoe UI;
    font-family: 'myfont' !important;
    font-weight: 600;
    color: #2e2e2e;
  }
  /* 去掉表格边框 */
  .customer-table td,
  .customer-table th.is-leaf {
    border: none;
  }
  /* 菜单树样式修改 */
  .el-checkbox__input .is-checked .el-checkbox__inner {
    background-color: #707070 !important;
    border-color: #707070;
  }
  .el-checkbox__input .el-checkbox__inner {
    border: 1px solid #000;
  }
  /* icon 大小 */
  .iconfont {
    width: 20px;
    height: 20px;
  }
  .number_card .iconfont {
    width: 60px;
    height: 60px;
  }
  /* 批量操作 */
  .batchOperation {
    display: flex;
    margin-bottom: 12px;
  }
  .batchOperation .left {
    margin-right: auto;
  }
  // 表格 弹窗
  .dialog_form {
    .batchOperation {
      display: flex;
      margin: 8px 10px;
    }
  }
  .dialog_form .el-dialog .el-dialog__body {
    padding: 0 0 0 10px;
  }
  /* 分页样式修改 */
  .el-pagination .is-background .el-pager li:not(.disabled) .active {
    border-radius: 50%;
    background: #696a6b;
  }
  .el-pagination .is-background .btn-next,
  .el-pagination .is-background .btn-prev,
  .el-pagination .is-background .el-pager li {
    border-radius: 50%;
  }
  .el-pagination__jump {
    margin: 0 20px;
  }
  // 表头字体修改
  .el-table th {
    font-size: 15px;
  }
  .el-table td{
	border-bottom: 1px solid #f5f5f5 !important;
  }
  /* 修改表格的行高 */
  .el-table td,
  .el-table th {
    // padding: 8px 0;
    padding: 8px 0;
  }
  .prepaid .el-table td,
  .prepaid .el-table th {
    padding: 11px 0 !important;
  }
  .el-table::before {
    height: 0;
  }
  // 表头高度
  .el-table thead tr {
    height: 36px;
  }
  .addformBox {
    > p {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-family: 'myfont' !important;
      font-weight: 400;
      line-height: 30px;
      color: #bbbbbb;
      margin: 0;
    }
    .ptitle {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-family: 'myfont' !important;
      font-weight: 400;
      line-height: 30px;
      color: #bbbbbb;
      margin: 0;
    }

    // border-bottom: 1px solid #d9d4d4;
  }
  // 抽屉样式
  .el-icon-d-arrow-right:before {
    font-size: 30px;
  }
  .el-icon-folder-add {
    padding: 2px 10px;
  }
  // 图片大小
  .el-image__inner {
    width: 100px;
    height: auto;
  }
  // 表单验证 * 颜色
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "*";
    color: #000000;
    margin-right: 1px;
  }
  .el-form-item p {
    margin: 0;
    // height: 12px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-family: 'myfont' !important;
    font-weight: 400;
    line-height: 20px;
    color: #959292;
    opacity: 1;
  }
  // 文字与框的间距
  .el-form-item__label {
    padding: 0 10px 0 0;
    color: #000;
  }
  .middle {
    opacity: 1;
    width: 100%;
    height: calc(100vh - 200px);
    overflow-y: auto;
    background-color: #fff;
    border-radius: 20px;
    padding: 10px 20px;
  }
  .middle-el-date-picker {
    width: 260px !important;
  }
  .middle1 {
    opacity: 1;
    width: 100%;
    height: calc(100vh - 500px);
    overflow-y: auto;
    background-color: #fff;
    border-radius: 20px;
    padding: 10px 20px;
  }
  .pay .el-form-item__label {
    height: 20px;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-family: 'myfont' !important;
    font-weight: 500;
    line-height: 34px;
    color: #000000;
    opacity: 1;
  }
  .pay-fixed {
    position: absolute;
    bottom: 20px;
  }
  .el-avatar > img {
    width: 100%;
  }
  .line1 {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-family: 'myfont' !important;
    font-weight: 400;
    line-height: 17px;
    color: #000000;
    opacity: 1;
    text-indent: 80px;
  }
  // 表单样式
  .line {
    display: flex;
    align-items: flex-start;
    text-align: start;
    align-items: center;
  }
  .tip {
    margin-bottom: 10px;
    font-size: 5px;
    font-family: Source Han Sans CN;
    font-family: 'myfont' !important;
    font-weight: 400;
    line-height: 17px;
    color: #000000;
    opacity: 1;
    text-indent: 6px;
  }
  .el-switch__core {
    margin: 0 0px 0 0;
  }
  .el-switch-nomargin span {
    margin: 0;
  }
  // 修改选择颜色
  .el-switch .is-checked .el-switch__core {
    border-color: #9d9999;
    background-color: #000;
  }
  .el-select .el-input__icon {
    line-height: 26px;
  }
  .custo_dialog .el-input-group__append {
    padding: 0;
    border-radius: 0 20px 20px 0;
  }
  .post_dialog .el-input-group__append {
    padding: 0;
    border-radius: 0 20px 20px 0;
  }
  /* 正常下拉框样式 */
  .el-select {
    border: none;
    opacity: 1;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-family: 'myfont' !important;
    font-weight: 400;
    color: #000000;
    padding: 0;
    width: 140px;
    margin-right: 6px;
  }
  /* 正常输入框 */
  .el-input {
    width: 140px;
    margin-right: 6px;
  }
  .el-input__inner {
    // border-radius: 20px;
	border: none;
	background: #F5F5F5;
  color: #333 !important;
  font-weight: 600;
  }
  .el-textarea__inner {
	border: none;
	background: #F5F5F5;
  color: #333 !important;
  font-weight: 600;
  }
  .el-range-input{
	background: #F5F5F5;
  }
  /* 大的输入框 */
  .big-input .el-input {
    width: 210px;
    margin-right: 6px;
  }
  .big-input .el-input__inner {
    // border-radius: 20px;
  }
  /* 短下拉框 */
  .mini-select {
    width: 67px;
    // border-radius: 15px;
    margin-right: 6px;
    .el-input {
      width: 67px;
    }
  }
  /* 中下拉框 */
  .normal-select {
    width: 80px !important;
    // border-radius: 15px;
    margin-right: 6px;
    .el-input {
      width: 80px !important;
    }
  }
  /* 中大下拉框 */
  .normal-big-select {
    width: 100px !important;
    border-radius: 15px;
    margin-right: 6px;
    .el-input {
      width: 100px !important;
    }
  }
  /* 大下拉框*/
  .normal-super-select {
    width: 210px !important;
    border-radius: 15px;
    margin-right: 6px;
    .el-input {
      width: 210px !important;
    }
  }
  //短输入框
  .mini-input {
    width: 67px;
    margin-right: 6px;
    // .el-input__inner {
    //   width: 67px;
    // }
  }
  // 中输入框
  .mid-input {
    width: 150px;
    .el-input__inner {
      width: 150px;
    }
  }
  // 长输入框
  .large-input {
    width: 180px;
    .el-input__inner {
      width: 180px;
    }
  }
  // 超长输入框
  .super-input {
    width: 210px;
    .el-input__inner {
      width: 210px;
    }
  }
  // 特长输入框
  .superPlus-input {
    width: 310px;
    .el-input__inner {
      width: 310px;
    }
  }
  //高输入框
  .heightinput .el-input__inner {
    height: 140px;
  }
  //中输入框
  .middleinput .el-input__inner {
    height: 100px;
  }
  //时间选择
  .small-date-picker {
    width: 220px !important;
  }
  .mini-date-picker {
    height: 28px !important;
    line-height: 28px !important;
  }

  .small-el-form-item .el-form-item {
    margin-bottom: 14px;
  }

  .btns .el-form-item__content {
    text-align: center;
  }

  .btns .login_box .login_form .btns .el-button,
  .btns .el-button--primary {
    border: none;
    background: #2a62ff;
    width: 274px !important;
    height: 35px;
    background: #2a62ff;
    // border-radius: 6px;
	border-radius: 0px !important;
  }
  .term_search .el-input__inner {
    background-color: #e9e6e6;
  }
  // 状态颜色
  .status_num {
    color: #f0a410;
  }
  .status_tip {
    color: #ced820;
  }
  .status_true {
    color: #2ec17c;
  }
  .status_false {
    color: #ff2963;
  }
  .status_not {
    color: #f98233;
  }
  .status_normal {
    color: #2895f5;
  }
  //操作按钮
  .operation {
    // border-radius: 3px;
  }
  // 删除按钮颜色
  .deleteBtn {
    border: none;
    background: #bea216;
  }
  // 停用按钮
  .red {
    background: #ff2963;
    border: none;
  }
  // 启用按钮
  .gree {
    background: #2ec17c;
    border: none;
  }
  //4g卡按钮
  .Lightblue {
    background: #82b1ff;
    border: none;
  }
  //操作 文本按钮
  .deletetext {
    color: #bea216;
  }
  .redtext {
    color: #ff340a;
  }
  .buletext {
    color: #2962ff;
  }
  .Lightbluetext {
    color: #2196f3;
  }
  .greetext {
    color: #0ca252;
  }
  .orangetext {
    color: #fe330a;
  }
  // 列表居中
  // 边框控制
  .el-table td,
  .el-table th {
    // text-align: center;
    border: 0;
    color: #000;
  }
  // 整体 有效滚动条 空白部分
  ::-webkit-scrollbar {
    width: 9px;
    height: 8px;
  }
  //滚动条 终端
  ::-webkit-scrollbar-corner {
    border-radius: 10px;
    background: #c0c4cc;
  }
  // 整体 滚动条 颜色
  ::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #c0c4cc;
  }
  //整体 滚动条 空白部分
  ::-webkit-scrollbar-track {
    // background: #dcdcdc;
    background: none;
    border-radius: 2px;
  }
  ::-ms-scrollbar {
    width: 6px;
    height: 24px;
  }
  ::-o-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 10px;
  }
  scrollbar-arrow-color {
    background: #c0c4cc;
  }

  /*IE滚动条颜色*/
  .iescroll {
    scrollbar-arrow-color: #333; /**/ /*三角箭头的颜色*/
    scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
    scrollbar-3dlight-color: #333; /**/ /*立体滚动条亮边的颜色*/
    scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
    scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
    scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
    scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
    scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
  }
  // 主界面 表单 清空按钮扁平化处理
  .el-button--primary.is-plain {
    background: none;
  }
  // 登录修改
  .login_input {
    width: 300px !important;
    .el-input {
      width: 300px !important;
    }
    input {
      width: 300px !important;
      height: 35px !important;
      border: 1px solid #b4b4b4;
      // border-radius: 5px;
    }
  }
  // 给所有的弹框垂直居中
  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    .el-dialog {
      margin-top: 0 !important;
      margin-bottom: 0px !important;
    }
  }
  .centerDialog .el-dialog {
    height: 86vh;
    overflow: hidden;
    .el-dialog__body {
      height: calc(100% - 100px);
      overflow-y: scroll;
    }
  }
  // 公告
  .con_overflow span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 220px;
    display: block;
  }
  //首页 商品概况
  .box3_content {
    width: 100%;
    padding: 0 10px 10px 15px;
    box-sizing: border-box;
    .el-table td,
    .el-table th.is-leaf {
      border: 0;
      padding: 1px 0;
      font-size: 14px;
      color: #000;
    }
    .el-table .cell {
      padding-right: 0;
    }
    .el-table__body-wrapper {
      height: 270px !important;
    }
  }
  //首页 设备概况
  .box4_content {
    width: 100%;
    position: relative;
    padding: 0px 10px 10px 15px;
    top:-68px;
    box-sizing: border-box;
    .el-table td,
    .el-table th.is-leaf {
      border: 0;
      padding: 7px 0;
      font-size: 14px;
      color: #000;
    }
    .el-table .cell {
      padding-right: 0;
    }
    .el-table__body-wrapper {
      height: 180px !important;
    }
  }
  .el-table--scrollable-x .el-table__body-wrapper {
    height: calc(100% - 40px);
  }
  // 菜单树
  .el-tree-node__content{
  	height: 40px;
  	line-height: 40px;
  	border-bottom: 1px solid #dedede;
  	position: relative;
	font-size: 14px;

	.custom-tree-btn{
		font-size: 12px !important;

		button{
			font-size: 12px !important;
		}
	}
  }
  .el-tree-node__expand-icon{
  	font-size: 25px;
  	color: #323333;
  }
  .long_text {
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }
  }

.book-introduction {
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    cursor: pointer;
  }
  a {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    cursor: pointer;
  }
}
.clearboth{
	clear: both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue